import {createStyles, makeStyles, Theme} from '@material-ui/core';
import {WHITE} from '../../../const/colors';
import {desktop, mobile} from '../../../const/sizes';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        formSection: {
            backgroundColor: WHITE,
            marginBottom: mobile.contentSmallerSpacing,
        },
        formSectionHeader: {
            fontSize: 18,
            fontWeight: 'bold',
            marginBottom: mobile.contentSmallerSpacing,
        },
        buyerDataTypeButton: {
            marginTop: mobile.contentSmallerSpacing,
            height: 40,
            borderRadius: 3,
        },
        disabledButton: {
            color: theme.palette.grey[800],
            borderColor: theme.palette.grey[800],
        },
        buyerDataForm: {
            marginTop: mobile.contentSmallerSpacing,
        },
        buyerDataType: {
            margin: 0
        },
        [theme.breakpoints.up('sm')]: {
            formSectionHeader: {
                fontSize: 20,
                marginBottom: desktop.contentSmallerSpacing,
            },
            buyerDataType: {
                display: 'flex',
                alignItems: 'flex-start',
                flexDirection: 'row',
                
            },
            buyerDataTypeButton: {
                maxWidth: 300,
                marginTop: 0,
                marginRight: desktop.contentSmallerSpacing,
            },
            buyerDataForm: {
                maxWidth: 800,
                marginTop: desktop.contentSmallerSpacing,
            }
        },
    }),
);

export default useStyles;
